import React from "react";
import { widgetData } from "./career-listing.data";
import { title, link } from "./career-listing.data";
import CustomButton from "../../../commons/custom-button/custom-button.component";
import "./career-lisiting.styles.scss";

//#RP - Task 124 Career
const CareerListing = ({data,avaData,subTitle}) => {
  //const data = widgetData;

  const handleApplyClick = (url) =>{
    if(url)
      window.open(url);
  }

  return (
    <div className="career-listing-no-pag-wrapper">
      <p className="title">{subTitle}</p>
      {data && data.map((position, i) => (
        <div key={i} className="widgetBox-wrapper">
          <div className="widget-wrapper">
            <div className="content">
              <p className="department_title">{position.Company}</p>
              <a href={position.RouteUrl} className="job_title">
                {position.JobTitle}
              </a>
              <p className="location">{position.JobLocation}</p>
              {/* <p className="location">{position.City}{position.State != "" ? ', '  + position.State : ""}</p> */}
              {/* <p className="multiple-locations">
                {position.multiple_locations}
              </p> */}
            </div>
            <CustomButton 
               className="d-block button-spacer" 
               onClick={() => handleApplyClick(position.RouteUrl)}
              >                
               Apply Now                
              </CustomButton>
          </div>
          <hr />
        </div>
      ))}
      <a href={avaData.RouteUrl} className="link">
        {link}
      </a>
    </div>
  );
};

export default CareerListing;
